import { Component } from '@angular/core';
import { LocalizationService } from 'src/services/localization.service';

@Component({
  standalone: false,
  selector: 'app-sidebar-nav',
  templateUrl: './sidebar-nav.html',
  styleUrl: './sidebar-nav.scss',
})
export class SidebarNav {

  constructor(public loc : LocalizationService) { }

}
